<script>
  export default {
    name: "CircleImg",
    props: {
      img: {
        type: String,
        default: "",
      },
      styles: {
        type: Object,
        default: () => ({
          width: "20px",
          height: "20px",
          borderColor: "#bd0909",
        }),
      },
      stylesImg: {
        type: Object,
        default: () => ({}),
      },
      alt: {
        type: String,
        default: "",
      },
      item: {
        type: Object,
      },
      variant: { type: String, default: "default" },
      useIconic: { type: Boolean, default: false },
    },
    methods: {
      onClick() {
        this.$emit("onClick", this.item);
      },
    },
  };
</script>

<template>
  <div :class="`CircleImg CircleImg--${variant}`" :style="styles" @click="onClick">
    <iconic v-if="useIconic" :name="img" class="CircleImg__img" />
    <img v-else :style="stylesImg" :src="img" :alt="alt" class="CircleImg__img" />
  </div>
</template>

<style lang="scss">
  .CircleImg {
    @include Flex();
    overflow: hidden;
    border-radius: 50px;
    background-color: #f0f0f0;
    &__img {
      width: 100%;
      height: 100%;
      font-size: 12px;
      object-fit: cover;
    }

    &--xIcon {
      @include Flex();
      background-color: $primary-color;
      color: #fff;

      .CircleImg__img {
        font-size: 12px;
      }
    }
  }
</style>
